<template>
  <div>
    <c-input
      v-model="data.name"
      label="Site name"
      class="input"
      type="text"
      placeholder="Site name"
      @keydown="allowSave"
    />
    <c-input
      v-model="data.siteAddress"
      label="Site URL"
      class="input"
      type="text"
      placeholder="Site URL"
      @keydown="allowSave"
    />

    <c-button-group>
      <c-button color="primary" :disabled="saving" @click="save">Save</c-button>
      <c-button v-if="showCancelButton" color="secondary" @click="cancelEdit">Reset</c-button>
    </c-button-group>
  </div>
</template>

<script>
import { buildEndpoint } from '@/libs/buildEndPoint';

export default {
  name: 'EditSiteDetails',
  props: {
    site: Object,
  },
  data() {
    return {
      error: null,
      saving: false,
      showCancelButton: false,
      data: {
        name: null,
        siteAddress: null,
      },
    };
  },

  mounted() {
    this.siteId = this.$route.params.siteId;
    this.setDefaults();
  },

  methods: {
    setDefaults() {
      this.data = {
        name: this.site.name,
        siteAddress: this.site.siteAddress,
      };
    },
    cancelEdit() {
      this.setDefaults();
      this.showCancelButton = false;
    },
    allowSave() {
      this.showCancelButton = true;
      // this.enableSave = true
    },
    save() {
      if (!this.data.name || !this.data.siteAddress) {
        return;
      }

      this.saving = true;
      this.error = null;

      const data = {
        id: this.siteId,
        name: this.data.name,
        siteAddress: this.data.siteAddress,
      };

      this.$http
        .post(buildEndpoint('site/update'), data)
        .then((response) => {
          this.saving = false;
          if (response.data.success) {
            this.showCancelButton = false;
            this.data = {
              name: this.data.name,
              siteAddress: this.data.siteAddress,
            };
            this.$store.commit('addSuccessMessage', {
              header: 'Success',
              message: 'Site updated successfully',
            });
            // this.$router.push({name: 'detailsSite', params: {siteId: this.siteId}})
            // all good
          } else {
            this.$store.commit('addErrorMessage', {
              header: 'Error updating site',
            });
          }
        })
        .catch((error) => {
          this.saving = false;
          this.error = error;
        });
    },
  },
};
</script>
